/**
 * mega-menu.js
 * 宮崎キャビア1983 カスタムヘッダー用インタラクション
 * - メガメニュー（ホバー展開 / キーボード操作）
 * - スティッキーヘッダー（スクロール検知）
 * ※ モバイルドロワーメニューはタスク2で実装予定
 */
(function () {
  'use strict';

  /* ── 定数 ── */
  const HOVER_OPEN_DELAY  = 120;  // ms: ホバー後に開くまでの遅延
  const HOVER_CLOSE_DELAY = 250;  // ms: ホバー離脱後に閉じるまでの猶予
  const STICKY_THRESHOLD  = 60;   // px: スティッキー発動スクロール量

  /* ── DOM 取得 ── */
  const header   = document.querySelector('.jcaviar-header');
  const trigger  = document.querySelector('[data-mega-menu-trigger] .jcaviar-header__nav-link--trigger');
  const wrapper  = document.querySelector('[data-mega-menu-wrapper]');
  const panel    = wrapper && wrapper.querySelector('.mega-menu__panel');
  const overlay  = document.querySelector('[data-mega-menu-overlay]');

  const hamburger = document.getElementById('jcaviar-hamburger'); // タスク2でドロワー接続予定

  /* ===== メガメニュー ===== */

  if (trigger && panel) {
    let openTimer  = null;
    let closeTimer = null;

    /** メガメニューを開く */
    function openMega() {
      clearTimeout(closeTimer);
      openTimer = setTimeout(() => {
        panel.classList.add('is-open');
        overlay && overlay.classList.add('is-visible');
        trigger.setAttribute('aria-expanded', 'true');
      }, HOVER_OPEN_DELAY);
    }

    /** メガメニューを閉じる */
    function closeMega(returnFocus) {
      clearTimeout(openTimer);
      closeTimer = setTimeout(() => {
        panel.classList.remove('is-open');
        overlay && overlay.classList.remove('is-visible');
        trigger.setAttribute('aria-expanded', 'false');
        if (returnFocus) trigger.focus();
      }, HOVER_CLOSE_DELAY);
    }

    /** 即時クローズ（猶予なし） */
    function closeMegaImmediately(returnFocus) {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      panel.classList.remove('is-open');
      overlay && overlay.classList.remove('is-visible');
      trigger.setAttribute('aria-expanded', 'false');
      if (returnFocus) trigger.focus();
    }

    function isMegaOpen() {
      return panel.classList.contains('is-open');
    }

    /* ── ホバー: トリガー ── */
    trigger.parentElement.addEventListener('mouseenter', openMega);
    trigger.parentElement.addEventListener('mouseleave', () => closeMega(false));

    /* ── ホバー: パネル（猶予でカーソル移動を許容） ── */
    panel.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    panel.addEventListener('mouseleave', () => closeMega(false));

    /* ── キーボード: Enter / Space でトグル ── */
    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        isMegaOpen() ? closeMegaImmediately(true) : openMega();
      }
      if (e.key === 'Escape') {
        closeMegaImmediately(true);
      }
    });

    /* ── キーボード: パネル内 Escape ── */
    panel.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeMegaImmediately(true);
      }
    });

    /* ── フォーカス離脱で閉じる ── */
    document.addEventListener('focusin', (e) => {
      if (!trigger.contains(e.target) && !panel.contains(e.target)) {
        closeMegaImmediately(false);
      }
    });

    /* ── オーバーレイクリックで閉じる ── */
    overlay && overlay.addEventListener('click', () => closeMegaImmediately(false));
  }

  /* ===== スティッキーヘッダー ===== */

  if (header && header.dataset.sticky === 'true') {
    let ticking = false;

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(() => {
          const scrolled = window.scrollY > STICKY_THRESHOLD;
          header.classList.toggle('is-scrolled', scrolled);
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    // 初期状態を確認
    onScroll();
  }


})();
